import React from 'react';

const NoTransactionsIcon = () => {
    return (
        <svg
            width='66'
            height='66'
            viewBox='0 0 66 66'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect x='5' y='5' width='56' height='56' rx='28' fill='#F2F4F7' />
            <rect
                x='5'
                y='5'
                width='56'
                height='56'
                rx='28'
                stroke='#F9FAFB'
                strokeWidth='10'
            />
            <path
                d='M33 25.4866H44.6667'
                stroke='#292D32'
                strokeWidth='1.5'
                stroke-miterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M35.59 21.3333H42.0767C44.1533 21.3333 44.6667 21.8466 44.6667 23.8999V28.6949C44.6667 30.7483 44.1533 31.2616 42.0767 31.2616H35.59C33.5133 31.2616 33 30.7483 33 28.6949V23.8999C33 21.8466 33.5133 21.3333 35.59 21.3333Z'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M21.3333 38.9033H32.9999'
                stroke='#292D32'
                strokeWidth='1.5'
                stroke-miterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M23.9233 34.75H30.4099C32.4866 34.75 32.9999 35.2633 32.9999 37.3167V42.1117C32.9999 44.165 32.4866 44.6783 30.4099 44.6783H23.9233C21.8466 44.6783 21.3333 44.165 21.3333 42.1117V37.3167C21.3333 35.2633 21.8466 34.75 23.9233 34.75Z'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M44.6667 36.5C44.6667 41.015 41.015 44.6667 36.5 44.6667L37.725 42.625'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M21.3333 29.4999C21.3333 24.9849 24.9849 21.3333 29.4999 21.3333L28.2749 23.3749'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default NoTransactionsIcon;
